<!-- 合约交易风险确认书 -->
<template>
  <c-dialog
    paddingTop="24px"
    paddingBottom="10px"
    :width="460"
    :showFlag="isShow"
    :confirmLoading="dialogConfirmLoading"
    :confirmDisabled="dialogConfirmDisabled"
    :titleText="$t('futures.openFutures.titleText')"
    :confirmText="$t('futures.openFutures.confirmText')"
    :closeText="$t('futures.openFutures.cancelText')"
    @close="close"
    @confirm="submit"
  >
    <div class="openFutures-box">
      <div class="tips gray-cl">{{ $t("futures.openFutures.openTips") }}</div>
      <div class="questionList">
        <div class="questionItem">
          <div class="question main-cl">{{ $t("futures.openFutures.question1") }}</div>
          <div class="answer" :class="{active: question1Ans1}">
            <c-checkBox :value="question1Ans1" @click="toggleQuestionCheckBox('question1Ans1', 'question1Ans2')"/>
            <span class="text gray-cl" :class="{'main-cl': question1Ans1}" @click="toggleQuestionCheckBox('question1Ans1', 'question1Ans2')">{{ $t("futures.openFutures.answer1_1") }}</span>
            <svg-icon icon-class="icon-right-answer"></svg-icon>
          </div>
          <div class="answer" :class="{active: question1Ans2}">
            <c-checkBox :value="question1Ans2" @click="toggleQuestionCheckBox('question1Ans2', 'question1Ans1')"/>
            <span class="text gray-cl" :class="{'main-cl': question1Ans2}" @click="toggleQuestionCheckBox('question1Ans2', 'question1Ans1')">{{ $t("futures.openFutures.answer1_2") }}</span>
            <svg-icon icon-class="icon-wrong-answer"></svg-icon>
          </div>
        </div>
        <div class="questionItem">
          <div class="question main-cl">{{ $t("futures.openFutures.question2") }}</div>
          <div class="answer" :class="{active: question2Ans1}">
            <c-checkBox :value="question2Ans1" @click="toggleQuestionCheckBox('question2Ans1', 'question2Ans2')" />
            <span class="text gray-cl" :class="{'main-cl': question2Ans1}" @click="toggleQuestionCheckBox('question2Ans1', 'question2Ans2')">{{ $t("futures.openFutures.answer2_1") }}</span>
            <svg-icon icon-class="icon-right-answer"></svg-icon>
          </div>
          <div class="answer" :class="{active: question2Ans2}">
            <c-checkBox :value="question2Ans2" @click="toggleQuestionCheckBox('question2Ans2', 'question2Ans1')"/>
            <span class="text gray-cl" :class="{'main-cl': question2Ans2}" @click="toggleQuestionCheckBox('question2Ans2', 'question2Ans1')">{{ $t("futures.openFutures.answer2_2") }}</span>
            <svg-icon icon-class="icon-wrong-answer"></svg-icon>
          </div>
        </div>
      </div>
      <div class="protocolArea">
        <c-checkBox :value="protocolChecked" @click="toggleQuestionCheckBox('protocolChecked')" />
        <span class="text" @click="toggleQuestionCheckBox('protocolChecked')">{{ $t("futures.openFutures.agreeText") }}</span>
        <a :href="$t('futures.openFutures.protocolLink')" target="_blank" class="blue-cl">
          {{ $t("futures.openFutures.agreeLink") }}
        </a>
      </div>
    </div>
  </c-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      default: false,
      type: Boolean,
    },
    close: {
      default() {},
      type: Function,
    },
  },
  data() {
    return {
      // 是否加载成功
      dialogConfirmLoading: false,
      question1Ans1: false,
      question1Ans2: false,
      question2Ans1: false,
      question2Ans2: false,
      protocolChecked: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    // 是否禁止提交
    dialogConfirmDisabled() {
      return !(this.question1Ans1 && this.question2Ans1 && this.protocolChecked);
    },
  },
  methods: {
    /**
     * 切换选中项
     * otherKey 需要互斥的另一个key,他俩不能同时选上
     */
    toggleQuestionCheckBox(key, otherKey) {
      this.$set(this, key, !this[key]);
      if (otherKey && this[key]) {
        this[otherKey] = false;
      }
    },
    // 开通合约交易
    submit() {
      const { mobileNumber, email, id } = this.userInfo;
      this.dialogConfirmLoading = true;
      this.axios({
        url: this.$store.state.url.futures.createCoId,
        hostType: 'co',
        method: 'post',
        params: {
          mobileNumber,
          email,
          uid: id,
        },
      }).then(({ code, msg }) => {
        if (code.toString() === '0') {
          // 防止数据更新不及时状态变化问题
          setTimeout(() => {
            this.$store.dispatch('getUserConfig');
          }, 500);
          this.close();
          this.$bus.$emit('tip', { text: msg, type: 'success' });
        } else {
          this.$bus.$emit('tip', { text: msg, type: 'error' });
        }
        this.dialogConfirmLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .dialog-frame-head-text {
  display: block;
  text-align: center;
}

/deep/ .dialog-frame-head-close {
  display: none;
}

.openFutures-box {
  .tips {
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 24px;
  }

  .questionList {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-size: 14px;
    line-height: 20px;

    .questionItem {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .answer {
        display: flex;
        gap: 8px;
        align-items: center;

        .text {
          cursor: pointer;
        }

        svg {
          display: none;
        }

        &.active {
          svg {
            display: inline-block;
          }
        }
      }
    }
  }

  .protocolArea {
    display: flex;
    gap: 8px;
    align-items: center;

    .text {
      cursor: pointer;
    }
  }
}
</style>
